import {
  Anchor,
  Checkbox,
  Container,
  Flex,
  Image,
  Progress,
  Radio,
  Text,
  Textarea,
} from "@mantine/core";
import { useEffect } from "react";
import { AwesomeButton } from "react-awesome-button";
import Main_Logo from "../../assets/logo/Logo.svg";
import { customButtonStyles } from "../../customButtonStyles";
import "./survey.css";

import { useSurvey } from "./Survey.context";

const Survey = () => {
  //context data
  const {
    questions,
    currQuestionIndex,
    updateCheckboxResponse,
    updateRadioResponse,
    updateOtherResponse,
    nextQuestion,
    prevQuestion,
    showSelectOptionMessage,
    showOthersMessage,
  } = useSurvey();

  //getting only one question based on current question index
  const currentSurveyQuestion = questions[currQuestionIndex];

  //getting checkbox respones
  const handleCheckboxChange = (value) => {
    updateCheckboxResponse(currentSurveyQuestion.id, value);
  };

  //getting radio button respones
  const handleRadioChange = (value) => {
    updateRadioResponse(currentSurveyQuestion.id, value);
  };

  //getting other field respones
  const handleOtherChange = (e) => {
    updateOtherResponse(currentSurveyQuestion.id, e.target.value);
  };

  //getting textbox respones
  const handletextboxChange = (e) => {
    updateRadioResponse(currentSurveyQuestion.id, e.target.value);
  };

  useEffect(() => {
    // Apply the styles if found
    if (customButtonStyles) {
      const styleTag = document.createElement("style");
      styleTag.innerHTML = customButtonStyles;
      document.head.appendChild(styleTag);
    }
  }, []); // Run only once on component mount

  const renderQuestion = () => {
    return (
      <Flex direction="column">
        <Text
          c="#dedede9b"
          style={{
            fontSize: 24,
            marginBottom: 4,
            // fontVariant: "all-petite-caps",
          }}
        >
          QUESTION
          <span> {currentSurveyQuestion.id}</span>
        </Text>
        <Text c={"white"} mb={20} style={{ fontSize: 25 }}>
          {currentSurveyQuestion.questionText}
        </Text>
        {currentSurveyQuestion.type === "radio" && (
          <Radio.Group
            // Use the stored response value for this question
            value={currentSurveyQuestion.response}
            // Handle answer change for this question
            onChange={handleRadioChange}
            c={"white"}
          >
            {currentSurveyQuestion.options.map((option, index) => (
              <Radio
                key={index}
                value={option}
                label={option}
                mb={20}
                size="lg"
                styles={{
                  label: {
                    fontSize: "1.5rem", // Adjust the font size of the label
                  },
                }}
              />
            ))}
          </Radio.Group>
        )}

        {currentSurveyQuestion.type === "checkbox" && (
          <Checkbox.Group
            // Use the stored response value for this question
            value={currentSurveyQuestion.response}
            // Handle answer change for this question
            onChange={handleCheckboxChange}
            c={"white"}
            mb={24}
          >
            {currentSurveyQuestion.options.map((option, index) => (
              <Checkbox
                key={index}
                value={option}
                label={option}
                mb={15}
                size="md"
                styles={{
                  label: {
                    fontSize: "1.5rem", // Adjust the font size of the label
                  },
                }}
              />
            ))}
          </Checkbox.Group>
        )}

        {
          currentSurveyQuestion.response?.includes(
            "Other (please specify)"
          ) && (
            <Textarea
              autoFocus
              placeholder="Please specify"
              // Use the stored response value for this question
              value={currentSurveyQuestion.others}
              // Handle other field change for this question
              onChange={handleOtherChange}
              radius={6}
              size="md"
            />
          )
          //   )
        }

        {currentSurveyQuestion.type === "textbox" && (
          <Textarea
            autoFocus
            placeholder="Enter your response"
            // Use the stored response value for this question
            value={currentSurveyQuestion.response}
            // Handle answer change for this question
            onChange={handletextboxChange}
            radius={6}
            size="lg"
          />
        )}
      </Flex>
    );
  };

  return (
    <Flex
      align="center"
      direction="column"
      py={16}
      px={24}
      gap={16}
      flex={1}
      maw={400}
      w={"100%"}
    >
      <Flex
        align="center"
        direction="column"
        // style={{ width: "100%" }}
        flex={1}
      >
        <Anchor
          href="https://www.dreamcatcherz.net/"
          target="_blank"
          style={{
            width: "55%",
            height: "auto",
          }}
        >
          <Image src={Main_Logo} style={{ height: "auto" }} align="center" />
        </Anchor>
        <Text mt={36} c="#ffffff">
          {`${currentSurveyQuestion.id} of ${questions.length}`}
        </Text>

        {/* Progress Bars */}

        <Container
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          {questions.map((_, index) => (
            <Progress
              key={index}
              color="#D4DC64"
              radius="lg"
              size="md"
              value={
                index < currentSurveyQuestion.id
                  ? 100
                  : index === currentSurveyQuestion.id
                  ? 0
                  : 0
              }
              w={46}
              striped
              animated
              mt={20}
            />
          ))}
        </Container>
      </Flex>

      {/* Question Card  */}

      <Flex
        bg="#012E38"
        direction="column"
        w="100%"
        p={25}
        flex={2}
        mt="xl"
        style={{
          borderRadius: 12,
        }}
      >
        {renderQuestion()}
      </Flex>

      {/* Container for Next/Back Button and Error Message */}

      <Flex
        direction="column"
        align="center"
        justify="center"
        flex={1}
        w={"100%"}
      >
        {showSelectOptionMessage && (
          <Text c="red" fontSize="xs" mb={8}>
            Please choose an option before proceeding.
          </Text>
        )}

        {showOthersMessage && (
          <Text c="red" fontSize="xs" mb={8}>
            Please specify details before proceeding.
          </Text>
        )}
        <Flex direction="row" gap={15}>
          <AwesomeButton
            className="custom-awesome-button"
            onPress={prevQuestion}
            style={{ width: "50%" }}
            disabled={currQuestionIndex === 0}
          >
            <Text size="xl" c="#004251" fw={600}>
              Back
            </Text>
          </AwesomeButton>
          <AwesomeButton
            className="custom-awesome-button"
            onPress={nextQuestion}
            style={{ width: "50%" }}
          >
            <Text size="xl" c="#004251" fw={600}>
              {currQuestionIndex === questions.length - 1 ? "Finish" : "Next"}
            </Text>
          </AwesomeButton>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Survey;
